import {
  SET_PASSPORT_DATA_CHILD,
  CHANGE_PASSPORT_DATA_CHILD,
  CHANGE_DOCUMENT_TYPE_CHILD,
  BLUR_PASSPORT_DATA_CHILD,
  LOAD_DRAFT_EMPTY
} from '../constants';
import cloneDeep from 'lodash/cloneDeep';
import { getCitizenshipByDocumentType } from '../../helpers/citizenship';
import { DOCUMENT_TYPE } from '../../constants/citizenship';
import passportEditableFields from '../serializers/passportEditableFields';
import Passport from '@mos-front-components/public/es/components/Passport';
const { BIRTH_CERTIFICATE_INTERNATIONAL, BIRTH_CERTIFICATE_RF } = DOCUMENT_TYPE;
const { FIELD_NAME } = Passport;

const initialState = {
  documents: [],
  data: {},
  firstState: null,
  firstCitizenship: '',
  editableFields: {},
  disabled: false,
  blur: {},
  loadedState: null
};

const passportChild = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSPORT_DATA_CHILD:
      const { citizenship, data } = action.payload;

      if (citizenship) {
        if (state.firstState && state.firstState[citizenship]) {
          return {
            ...state.firstState[citizenship],
            firstState: cloneDeep(state.firstState)
          };
        }

        return {
          ...initialState,
          firstState: cloneDeep(state.firstState)
        };
      }

      const firstCitizenship = getCitizenshipByDocumentType(data.documentType);
      const firstState = firstCitizenship
        ? {
            [firstCitizenship.name]: cloneDeep(action.payload)
          }
        : null;

      return {
        ...state,
        ...action.payload,
        firstState,
        firstCitizenship,
        blur: {}
      };
    case CHANGE_DOCUMENT_TYPE_CHILD:
      const documentType = action.payload.data.documentType;
      const selectData = citizenship => state.firstState[citizenship].data;
      const getPassport = data => ({
        documentType,
        [FIELD_NAME.byWhom]: data.byWhom || '',
        [FIELD_NAME.dateOfIssue]: data.dateOfIssue || '',
        [FIELD_NAME.number]: data.number || ''
      });
      const citizenshipRf = 'Гражданин РФ';
      const foreignCitizenship = 'Иностранный гражданин';
      const isForeignFirstState = !!state.firstState[foreignCitizenship];

      if (
        documentType === BIRTH_CERTIFICATE_INTERNATIONAL &&
        isForeignFirstState
      ) {
        const firstStateData = selectData(foreignCitizenship);

        if (firstStateData?.documentType === BIRTH_CERTIFICATE_INTERNATIONAL) {
          return {
            ...state,
            data: {
              ...firstStateData
            },
            editableFields: passportEditableFields(getPassport(firstStateData)),
            disabled: true,
            blur: {}
          };
        }

        return {
          ...state,
          data: {
            ...action.payload.data
          },
          disabled: false,
          blur: {}
        };
      }

      if (documentType === BIRTH_CERTIFICATE_RF && !isForeignFirstState) {
        const firstStateData = selectData(citizenshipRf);

        if (firstStateData?.documentType === BIRTH_CERTIFICATE_RF) {
          return {
            ...state,
            data: {
              ...firstStateData
            },
            editableFields: passportEditableFields(getPassport(firstStateData)),
            disabled: true,
            blur: {}
          };
        }

        return {
          ...state,
          data: {
            ...action.payload.data
          },
          disabled: false,
          blur: {}
        };
      }

      return {
        ...state,
        ...action.payload,
        blur: {}
      };
    case BLUR_PASSPORT_DATA_CHILD:
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case CHANGE_PASSPORT_DATA_CHILD:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        },
        blur: {
          ...state.blur,
          [action.payload.field]: false
        }
      };
    case LOAD_DRAFT_EMPTY:
      if (!state.firstState) {
        return {
          ...initialState
        };
      }

      return {
        ...initialState,
        ...state.firstState[state.firstCitizenship.name],
        firstState: {
          [state.firstCitizenship.name]: {
            ...state.firstState[state.firstCitizenship.name]
          }
        },
        firstCitizenship: state.firstCitizenship
      };
    default:
      return state;
  }
};

export default passportChild;
